import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 57 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M23.73 44.904V40.58C14.692 38.435 7.95 30.281 7.95 20.57 7.95 9.23 17.148 0 28.45 0c11.3 0 20.498 9.23 20.498 20.57 0 9.711-6.743 17.865-15.78 20.01v4.324a91 91 0 0 0-4.72 2.41 97 97 0 0 0-4.72-2.41Zm17.127-24.333c0-6.868-5.57-12.45-12.408-12.45s-12.407 5.582-12.407 12.45 5.563 12.45 12.407 12.45 12.408-5.589 12.408-12.45" }, null, -1),
    _createElementVNode("path", { d: "M1.585 44.843a94.5 94.5 0 0 1 26.912 9.812 94.7 94.7 0 0 1 26.918-9.819L57 52.802a86.9 86.9 0 0 0-26.48 10.022L28.497 64l-2.023-1.177A86.6 86.6 0 0 0 0 52.8l1.585-7.958Z" }, null, -1)
  ]))]))
}
export default { render: render }